/** Mirrors new-ui `mockData.ts` for marketplace events + detail page. */

export const mockEvents = [
  {
    id: "1",
    title: "Taylor Swift — Eras Tour",
    category: "Concerts",
    date: "Fri, Mar 14 · 7:00 PM",
    time: "7:00 PM",
    venue: "SoFi Stadium",
    city: "Los Angeles, CA",
    price: 189,
    image: "https://images.unsplash.com/photo-1449748040579-354c191a7934?w=800&q=80",
    featured: true,
    badge: "HOT",
    badgeColor: "bg-red-600",
    totalTickets: 1200,
    soldTickets: 1140,
    description:
      "Experience the magic of Taylor Swift's record-breaking Eras Tour, spanning her entire discography from debut to Midnights. A spectacular 3+ hour show featuring elaborate stage designs, stunning visuals, and unforgettable performances.",
    lineup: ["Taylor Swift", "Sabrina Carpenter (Opening)"],
    organizer: { id: "org1", name: "Live Nation", avatar: "LN" },
  },
  {
    id: "2",
    title: "Lakers vs Golden State",
    category: "Sports",
    date: "Sat, Mar 15 · 7:30 PM",
    time: "7:30 PM",
    venue: "Crypto.com Arena",
    city: "Los Angeles, CA",
    price: 94,
    image: "https://images.unsplash.com/photo-1626003573503-2e088d82c647?w=800&q=80",
    featured: true,
    badge: "PLAYOFFS",
    badgeColor: "bg-blue-600",
    totalTickets: 800,
    soldTickets: 720,
    description:
      "The rivalry continues! Watch the Los Angeles Lakers take on the Golden State Warriors in this epic NBA showdown. Don't miss LeBron James and Steph Curry go head to head.",
    lineup: [],
    organizer: { id: "org2", name: "AEG Presents", avatar: "AE" },
  },
  {
    id: "3",
    title: "Hamilton — Broadway",
    category: "Theater",
    date: "Sun, Mar 16 · 8:00 PM",
    time: "8:00 PM",
    venue: "Pantages Theatre",
    city: "Hollywood, CA",
    price: 149,
    image: "https://images.unsplash.com/photo-1767979400753-68241ee99633?w=800&q=80",
    featured: true,
    badge: "LIMITED",
    badgeColor: "bg-amber-600",
    totalTickets: 500,
    soldTickets: 485,
    description:
      "The story of America then, told by America now. Hamilton is the story of the unlikely Founding Father determined to make his mark on the new nation as hungry and ambitious as he is.",
    lineup: [],
    organizer: { id: "org3", name: "Broadway LA", avatar: "BL" },
  },
  {
    id: "4",
    title: "Red Sox vs. Yankees",
    category: "Sports",
    date: "Mon, Mar 17 · 6:00 PM",
    time: "6:00 PM",
    venue: "Fenway Park",
    city: "Boston, MA",
    price: 67,
    image: "https://images.unsplash.com/photo-1763246168695-36dc30e507ab?w=800&q=80",
    featured: true,
    badge: "RIVALRY",
    badgeColor: "bg-green-700",
    totalTickets: 600,
    soldTickets: 410,
    description:
      "Baseball's greatest rivalry returns to Fenway Park. Watch the Boston Red Sox take on the New York Yankees in this classic American League showdown.",
    lineup: [],
    organizer: { id: "org2", name: "AEG Presents", avatar: "AE" },
  },
  {
    id: "5",
    title: "Dave Chappelle Live",
    category: "Comedy",
    date: "Wed, Mar 19 · 8:30 PM",
    time: "8:30 PM",
    venue: "Madison Square Garden",
    city: "New York, NY",
    price: 79,
    image: "https://images.unsplash.com/photo-1762537132884-cc6bbde0667a?w=800&q=80",
    featured: true,
    badge: "NEW",
    badgeColor: "bg-emerald-600",
    totalTickets: 400,
    soldTickets: 320,
    description:
      "Comedy legend Dave Chappelle brings his unmatched wit and storytelling to MSG for a night of unforgettable stand-up comedy. An intimate evening with one of the greatest comedians of our generation.",
    lineup: ["Dave Chappelle", "Donnell Rawlings (Opening)"],
    organizer: { id: "org1", name: "Live Nation", avatar: "LN" },
  },
  {
    id: "6",
    title: "Coachella 2026 — Wknd 1",
    category: "Festivals",
    date: "Sat, Apr 12 · 12:00 PM",
    time: "All Day",
    venue: "Empire Polo Club",
    city: "Indio, CA",
    price: 399,
    image: "https://images.unsplash.com/photo-1761926826313-a1787661b7b6?w=800&q=80",
    featured: true,
    badge: "FESTIVAL",
    badgeColor: "bg-red-600",
    totalTickets: 2000,
    soldTickets: 1850,
    description:
      "The world's most iconic music and arts festival returns to the desert. Three days of incredible performances, art installations, and unforgettable experiences.",
    lineup: ["Kendrick Lamar", "Billie Eilish", "Travis Scott", "Doja Cat", "Tyler, The Creator"],
    organizer: { id: "org4", name: "Goldenvoice", avatar: "GV" },
  },
  {
    id: "7",
    title: "Kendrick Lamar — Grand National Tour",
    category: "Concerts",
    date: "Fri, Mar 28 · 8:00 PM",
    time: "8:00 PM",
    venue: "Crypto.com Arena",
    city: "Los Angeles, CA",
    price: 124,
    image: "https://images.unsplash.com/photo-1658046413536-6e5933dfd939?w=800&q=80",
    featured: false,
    badge: "SELLING FAST",
    badgeColor: "bg-red-600",
    totalTickets: 900,
    soldTickets: 870,
    description: "Kendrick Lamar brings his Grand National Tour to LA for an electrifying night of hip-hop excellence.",
    lineup: ["Kendrick Lamar", "SZA (Special Guest)"],
    organizer: { id: "org1", name: "Live Nation", avatar: "LN" },
  },
  {
    id: "8",
    title: "Electric Daisy Carnival",
    category: "Festivals",
    date: "Fri, May 16 · 7:00 PM",
    time: "7:00 PM",
    venue: "Las Vegas Motor Speedway",
    city: "Las Vegas, NV",
    price: 349,
    image: "https://images.unsplash.com/photo-1583376102242-5a6aad625ce5?w=800&q=80",
    featured: false,
    badge: "EDC",
    badgeColor: "bg-purple-600",
    totalTickets: 3000,
    soldTickets: 2200,
    description:
      "The world's largest electronic music festival. Three nights under the electric sky with 200+ artists across 8 stages.",
    lineup: ["Skrillex", "Tiësto", "Martin Garrix", "Zedd", "Deadmau5"],
    organizer: { id: "org5", name: "Insomniac Events", avatar: "IE" },
  },
  {
    id: "9",
    title: "Kevin Hart — Acting My Age Tour",
    category: "Comedy",
    date: "Sat, Apr 5 · 7:00 PM",
    time: "7:00 PM",
    venue: "The Forum",
    city: "Inglewood, CA",
    price: 98,
    image: "https://images.unsplash.com/photo-1762537132884-cc6bbde0667a?w=800&q=80",
    featured: false,
    badge: "LAST SEATS",
    badgeColor: "bg-orange-600",
    totalTickets: 500,
    soldTickets: 490,
    description: "Kevin Hart brings his latest tour to The Forum for a night of non-stop laughter.",
    lineup: ["Kevin Hart"],
    organizer: { id: "org1", name: "Live Nation", avatar: "LN" },
  },
  {
    id: "10",
    title: "TechCrunch Disrupt 2026",
    category: "Conferences",
    date: "Mon, Sep 15 · 9:00 AM",
    time: "9:00 AM",
    venue: "Moscone Center",
    city: "San Francisco, CA",
    price: 299,
    image: "https://images.unsplash.com/photo-1560523159-94c9d18bcf27?w=800&q=80",
    featured: false,
    badge: "TECH",
    badgeColor: "bg-blue-600",
    totalTickets: 1000,
    soldTickets: 650,
    description:
      "The premier tech startup conference featuring keynotes, pitch competitions, and networking with the brightest minds in technology.",
    lineup: [],
    organizer: { id: "org6", name: "TechCrunch", avatar: "TC" },
  },
  {
    id: "11",
    title: "LA Galaxy vs LAFC — El Tráfico",
    category: "Sports",
    date: "Sat, Apr 19 · 7:30 PM",
    time: "7:30 PM",
    venue: "BMO Stadium",
    city: "Los Angeles, CA",
    price: 65,
    image: "https://images.unsplash.com/photo-1679391029864-d46f366a456b?w=800&q=80",
    featured: false,
    badge: "DERBY",
    badgeColor: "bg-emerald-600",
    totalTickets: 700,
    soldTickets: 580,
    description: "The biggest rivalry in MLS! LA Galaxy takes on LAFC in the El Tráfico derby.",
    lineup: [],
    organizer: { id: "org2", name: "AEG Presents", avatar: "AE" },
  },
  {
    id: "12",
    title: "Billie Eilish — Hit Me Hard Tour",
    category: "Concerts",
    date: "Thu, Apr 10 · 8:00 PM",
    time: "8:00 PM",
    venue: "Hollywood Bowl",
    city: "Los Angeles, CA",
    price: 145,
    image: "https://images.unsplash.com/photo-1658046413536-6e5933dfd939?w=800&q=80",
    featured: false,
    badge: "HOT",
    badgeColor: "bg-red-600",
    totalTickets: 800,
    soldTickets: 760,
    description: "Billie Eilish brings her Hit Me Hard and Soft Tour to the iconic Hollywood Bowl.",
    lineup: ["Billie Eilish"],
    organizer: { id: "org1", name: "Live Nation", avatar: "LN" },
  },
  {
    id: "13",
    title: "Skyline Rooftop Sessions",
    category: "Nightlife",
    date: "Fri, Jul 4 · 10:00 PM",
    time: "10:00 PM",
    venue: "River North Lounge",
    city: "Chicago, IL",
    price: 0,
    image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&q=80",
    featured: false,
    badge: "FREE",
    badgeColor: "bg-emerald-600",
    totalTickets: 200,
    soldTickets: 120,
    description: "Free entry rooftop DJ sets with skyline views — first come, first served.",
    lineup: ["DJ North Wind"],
    organizer: { id: "org7", name: "Windy City Nights", avatar: "WN" },
  },
];

export const ticketTypes = [
  { id: "1", name: "General Admission", price: 149, available: 234, description: "Standing room, access to all GA areas" },
  { id: "2", name: "VIP Package", price: 299, available: 45, description: "Premium viewing area, complimentary drinks, merch bag" },
  { id: "3", name: "Premium Seating", price: 219, available: 89, description: "Reserved seat in premium section with great sightlines" },
  { id: "4", name: "Early Bird Special", price: 99, available: 12, description: "Limited early access pricing — first come, first served" },
];

export const faqItems = [
  {
    q: "Are all tickets guaranteed authentic?",
    a: "Yes. Every ticket sold on InstaPass is 100% verified and guaranteed. If there's ever an issue, you'll receive a full refund or comparable replacement tickets.",
  },
  {
    q: "How do I receive my tickets?",
    a: 'Tickets are delivered instantly to your email and available in your InstaPass account under "My Tickets". You can also access them via our mobile app.',
  },
  {
    q: "Can I get a refund?",
    a: "Refund policies vary by event. Check the specific event page for details. If an event is cancelled, you'll automatically receive a full refund.",
  },
  {
    q: "What if the event is sold out?",
    a: "You can join our waitlist to be notified if tickets become available. We also have a verified resale marketplace where fans can safely resell tickets.",
  },
  {
    q: "How does the QR code entry work?",
    a: "Each ticket includes a unique QR code. Simply show it on your phone at the venue entrance — no printing required. Our SmartCode technology ensures fast, secure scanning.",
  },
  {
    q: "Can I transfer tickets to someone else?",
    a: "Yes! You can transfer tickets to another person directly from your account. The recipient will receive their own unique QR code for entry.",
  },
];
